// ============================================================
// AAO · Tipos TypeScript — espejo del modelo de datos backend
// ============================================================
 
// ── Enums ─────────────────────────────────────────────────────────────────────
 
export type DominioEnum = "D1" | "D2" | "D3" | "D4" | "D5" | "Hub IA" | "Por asignar";
export type RolEnum = "Administrador" | "Manager" | "Domain Lead" | "IABP Owner" | "Tech Lead" | "Colaborador" | "Solo lectura";
export type PrioridadEnum = "Urgente" | "Alta" | "Media" | "Baja";
export type RAGEnum = "Verde" | "Ámbar" | "Rojo";
export type FaseEnum = "F0" | "F1" | "Triage CAI" | "F2" | "F3" | "F4";
 
export type EstadoSolicitudEnum =
  | "Nueva" | "En revisión" | "Aprobada→Proyecto"
  | "En desarrollo IABP" | "Escalada" | "Descartada" | "En espera";
 
export type TipoSolicitudEnum =
  | "IA/Agente" | "Automatización" | "Análisis de datos" | "Mejora de proceso" | "Mixto";
 
export type NivelEnum = "Baja" | "Media" | "Alta";
 
export type EstadoQWEnum = "En curso" | "Entregado" | "En espera" | "Descartado";
 
export type EstadoProyectoEnum =
  | "Scoping" | "Estimating" | "Approving" | "Scheduling"
  | "Developing" | "UAT" | "Deploying" | "Finished" | "Cancelled";
 
export type TipoProyectoEnum =
  | "Proyecto cliente" | "Proyecto interno" | "Innovación interna"
  | "Assessment" | "Quick Win escalado" | "FAB corporativo";
 
export type LineaProyectoEnum = "Línea A" | "Línea B" | "Línea C";
export type EstadoCAIEnum = "Pendiente" | "En triage" | "Aprobado" | "Condicionado" | "Rechazado" | "N/A";
export type RAGColor = "#52c41a" | "#faad14" | "#ff4d4f";
 
export type EstadoOportunidadEnum =
  | "Nueva" | "En análisis" | "En preparación" | "Enviada"
  | "En seguimiento" | "Ganada" | "Perdida" | "En pausa" | "Cancelada";
 
export type EstadoTareaEnum =
  | "Pendiente" | "En curso" | "En revisión" | "Bloqueada" | "Completada" | "Cancelada";
 
// ── Entidades ─────────────────────────────────────────────────────────────────
 
export interface Usuario {
  id: string;
  email: string;
  nombre: string;
  apellidos?: string;
  nombre_completo: string;
  rol: { nombre: RolEnum };
  activo: boolean;
}
 
export interface Dominio {
  id: string;
  codigo: DominioEnum;
  nombre: string;
  mandato?: string;
}
 
export interface SolicitudArea {
  id: string;
  sol_id: string;
  area_solicitante: string;
  solicitante_nombre: string;
  sponsor_area?: string;
  descripcion_pain_point: string;
  tipo_solicitud: TipoSolicitudEnum;
  herramienta_propuesta?: string;
  esfuerzo_estimado_iabp: NivelEnum;
  impacto_esperado: NivelEnum;
  complejidad: NivelEnum;
  prioridad: PrioridadEnum;
  estado: EstadoSolicitudEnum;
  requiere_datos_sensibles: boolean;
  requiere_triage_cai: boolean;
  siguiente_paso?: string;
  comentarios?: string;
  iabp_owner_id: string;
  dominio_id?: string;
  sugerir_quick_win: boolean;
  puede_crear_proyecto: boolean;
  created_at: string;
  updated_at: string;
}
 
export interface QuickWin {
  id: string;
  qw_id: string;
  titulo: string;
  descripcion?: string;
  area_solicitante: string;
  tipo_solucion: string;
  herramienta_usada?: string;
  estado: EstadoQWEnum;
  esfuerzo_real_dias?: number;
  fecha_entrega?: string;
  impacto_medido?: string;
  replicable: boolean;
  publicado_catalogo: boolean;
  iabp_owner_id: string;
  created_at: string;
}
 
export interface BusinessCase {
  id: string;
  proyecto_id: string;
  tipo_retorno?: string;
  objetivo_estrategico?: string;
  valor_economico_estimado?: number;
  coste_estimado_implementacion?: number;
  beneficio_mensual_estimado?: number;
  beneficio_anual_estimado?: number;
  roi_porcentaje?: number;
  payback_meses?: number;
  beneficio_neto?: number;
  nivel_confianza?: string;
  estado_validacion: string;
}
 
export interface Proyecto {
  id: string;
  proj_id: string;
  planner_id_original?: string;
  nombre: string;
  tipo: TipoProyectoEnum;
  linea: LineaProyectoEnum;
  cliente_area?: string;
  vertical?: string;
  mercado?: string;
  estado_cliente?: string;
  sponsor?: string;
  project_owner_id: string;
  dominio_id?: string;
  fase: FaseEnum;
  estado: EstadoProyectoEnum;
  estado_rag: RAGEnum;
  porcentaje_avance: number;
  prioridad: PrioridadEnum;
  tiene_ia: boolean;
  tipo_tecnologia?: string;
  nivel_madurez_ia?: string;
  estado_cai: EstadoCAIEnum;
  fecha_inicio?: string;
  fecha_fin_prevista?: string;
  fecha_fin_real?: string;
  fecha_ultimo_cambio?: string;
  bloqueantes?: string;
  notas_proximos_pasos?: string;
  business_case?: BusinessCase;
  created_at: string;
  updated_at: string;
}
 
export interface Oportunidad {
  id: string;
  opp_id: string;
  nombre: string;
  cliente?: string;
  tipo: string;
  estado: EstadoOportunidadEnum;
  prioridad: string;
  probabilidad_exito?: number;
  valor_estimado?: number;
  valor_ponderado?: number;
  fecha_limite_entrega?: string;
  proxima_accion?: string;
  alerta_fecha_limite: boolean;
  created_at: string;
}
 
export interface Tarea {
  id: string;
  task_id: string;
  titulo: string;
  tipo: string;
  estado: EstadoTareaEnum;
  prioridad: string;
  responsable_id?: string;
  proyecto_id?: string;
  fecha_compromiso?: string;
  porcentaje_completado: number;
  esta_vencida: boolean;
}
 
// ── Dashboard / Reporting ─────────────────────────────────────────────────────
 
export interface DashboardKPIs {
  total_solicitudes_activas: number;
  total_proyectos_activos: number;
  proyectos_rag: { Verde: number; Ámbar: number; Rojo: number };
  quick_wins_semana: number;
  oportunidades_activas: number;
  proyectos_sin_actualizar: number;
  cai_pendientes: number;
  proximos_hitos: { nombre: string; fecha: string; proyecto_id: string }[];
}
 
// ── API Response wrappers ─────────────────────────────────────────────────────
 
export interface PaginatedResponse<T> {
  total: number;
  items: T[];
}
 
export interface ApiError {
  detail: string;
}
 
// ── RAG Color mapping ─────────────────────────────────────────────────────────
 
export const RAG_COLORS: Record<RAGEnum, string> = {
  "Verde": "#52c41a",
  "Ámbar": "#faad14",
  "Rojo": "#ff4d4f",
};
 
export const RAG_ICONS: Record<RAGEnum, string> = {
  "Verde": "🟢",
  "Ámbar": "🟡",
  "Rojo": "🔴",
};